<template >
  <div  class="card-2022-dark leg-grid" 
        id="legend" 
        v-bind:style="{ 'min-height': getHeight + 'px;' }"
        v-bind:class="{ 'leg-wide': isWide }">
  
   <div v-if="thresholds" class="leg-grid">
      <div  class="mx-2"> 
        <div  class="leg-center leg-item leg-header"> 
          <div class="h3-dark h3-type narrow_05">{{ getTitleText }} <span class="text8pt">({{ !subTitleText ? $t('Webportal.DashboardBMW.AllValuesInPercent') : subTitleText}})</span></div>
        </div>
      </div>
    
      <div  class="mx-2 leg-item" >
        <div class="legctrl-box">
          <div class="legctrl-tab">
            <div  class="legctrl-cell rounded2"
                  :style="{ 'background-color': thresholds[0].Color }" >{{ getTextRed(thresholds) }}</div>
            <div  class="legctrl-cell rounded2"
                  :style="{ 'background-color': thresholds[1].Color }">{{ getTextYellow(thresholds) }}</div>
            <div  class="legctrl-cell rounded2"
                  :style="{ 'background-color': thresholds[2].Color }">{{ getTextGreen(thresholds) }}</div>
          </div>
        </div>
      </div>
    </div>

    <div  v-if="leadFuThresholds" class="leg-grid">
      <div  class="mx-2">
        <div class="leg-center leg-item leg-header">
          <div class="h3-dark h3-type narrow_05">{{ getTitleText }} <span class="text8pt">({{ $t('Webportal.DashboardBMW.Lead') }} {{ $t('Webportal.DashboardBMW.FollowUp') }} [%])</span></div>
        </div>
      </div>

      <div class="mx-2 leg-item">
        <div class="legctrl-box">
          <div class="legctrl-tab">
            <div  class="legctrl-cell rounded2"
                  :style="{ 'background-color': leadFuThresholds[0].Color }" >{{ getTextRed(leadFuThresholds) }}</div>
            <div  class="legctrl-cell rounded2"
                  :style="{ 'background-color': leadFuThresholds[1].Color }">{{ getTextYellow(leadFuThresholds) }}</div>
            <div  class="legctrl-cell rounded2"
                  :style="{ 'background-color': leadFuThresholds[2].Color }">{{ getTextGreen(leadFuThresholds) }}</div>
          </div>
        </div>
      </div>
    </div>

    <div  v-if="lmThresholds" class="leg-grid">
      <div  class="mx-2">
        <div class=" leg-center leg-item leg-header">
          <div class="h3-dark h3-type narrow_05">{{ getTitleText }} <span class="text8pt">({{$t('Webportal.DashboardBMW.LMxEvMyApp')}})</span></div>
        </div>
      </div>
      
      <div class="mx-2">
        <div  class="legctrl-box leg-item">
          <div class="legctrl-tab">
            <div  class="legctrl-cell rounded2"
                  :style="{ 'background-color': lmThresholds[0].Color }" >{{ getTextRed(lmThresholds) }}</div>
            <div  class="legctrl-cell rounded2"
                  :style="{ 'background-color': lmThresholds[1].Color }">{{ getTextYellow(lmThresholds) }}</div>
            <div  class="legctrl-cell rounded2"
                  :style="{ 'background-color': lmThresholds[2].Color }">{{ getTextGreen(lmThresholds) }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="mx-2">

      <div v-if="showTextItems" class="legctrl-box">
        <div class="legctrl-tab">
          <div class="legctrl-cell10"><font-awesome-icon name="fa-thumbs-up" icon="star"></font-awesome-icon></div>
          <div class="legctrl-cell90" >{{ workingStandardsText }}</div>
        </div>
      </div>

      <div v-if="showTextItems" class="legctrl-box">
        <div class="legctrl-tab">
          <div class="legctrl-cell20">
            <div class="legctrl-borderbox" ><div></div></div>
          </div>
          <div class="legctrl-cell80">{{ successFactorsText }}</div>
        </div>
      </div>

      <div v-if="showNpsInfo" class="legctrl-box">
        <div class="legctrl-tab">
          <div class="legctrl-cell90">*{{$t('Webportal.Dashboard.NPS')}} ({{$t('Webportal.Dashboard.Score')}} = {{$t('Webportal.DashboardBMW.Promoters')}}-{{$t('Webportal.DashboardBMW.Detractors')}})</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ThresholdColorMixin from '@/mixins/bmw/ThresholdColor';

  export default {
    mixins: [ ThresholdColorMixin ],

    props: {
      titleTextKey: { type: String, default: 'Webportal.DashboardBMW.PerformanceIndex' },
      titleText: { type: String, default: undefined },
      subTitleText: { type: String, default: undefined },
      workingStandardsText: { type: String, default: '' },
      successFactorsText: { type: String, default: '' },
      showTextItems: { type: Boolean, default: true },
      showNpsInfo: { type: Boolean, default: false },
      thresholds: { type: Array, required: false, default: undefined },
      leadFuThresholds: { type: Array, required: false, default: undefined },
      leadFuText: { type: String, required: false, default: undefined },
      lmThresholds: { type: Array, required: false, default: undefined },
      lmText: { type: String, required: false, default: undefined },
      isWide: { type: Boolean, required: false, default: false }
    },

    methods: {
      getTextRed(items) { return this.getThresholdText(items, items[0]); },
      getTextYellow(items) {return this.getThresholdText(items, items[1]); },
      getTextGreen(items) { return this.getThresholdText(items, items[2]); }
    },

    computed: {
      getTitleText: function() {
        if (_.isEmpty(this.titleText)) {
          return this.$t(this.titleTextKey);
        }
        return this.titleText;
      },
      getHeight: function() {
        return this.showNpsInfo ? 80 : 135;
      }
    }
  }
</script>

<style lang="scss" scoped>

  .card-body-spacer {
    padding: 0px;
  }


  #legend{
    position: relative;
    bottom:0px;
    background: transparent;
    /* height: 136px; */
  }

  .leg{
    position: relative;
    bottom:0px;
    background: transparent;
  }
  .leg-grid {
    grid-template-rows: 1fr 1fr;
    min-height: 62px;
  }
  .leg-wide {
    width: 17rem!important;
  }
  .leg-center {
    text-align: center;
  }
  .leg-item {
    padding: 0.25rem 0rem;
    height: 28px;
  }
  .leg-header {
    margin-left: 0.333rem;
  }
</style>
